import { store } from '../../../redux/store'
import MeterService from "../MeterService";
import { dataChanged } from './meterListSlice'
import ArrayUtils from "../../../utils/ArrayUtils";
import RequestQueue from "../../../utils/net/RequestQueue";

let isInitialized = false
let queue;

if (!isInitialized) {
    isInitialized = true
    queue = new RequestQueue()
    queue.subscribe({
        success: function (r) {
            const state = store.getState()

            if (state.meterList.requestParams.offset > 0) {
                r.data.items = ArrayUtils.merge(state.meterList.data.items, r.data.items, (i) => i.id)
            }

            store.dispatch(dataChanged(r.data))
        },
        error: function (r) {
            // TODO: rozwazyc powiadomienie uzytkownika o bledzie.
            console.error(r)
        },
        complete: function (r) {
            console.debug('Stream of meter list request has been completed.')
        } 
    })
}

const MeterListDataManager = {
    load: function() {
        const state = store.getState()
        queue.addRequest(MeterService.findMeters(state.meterList.requestParams))
    }
}

export default MeterListDataManager